import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsExchange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17 13.0001C17.5523 13.0001 18 13.4478 18 14.0001C18 14.5523 17.5523 15.0001 17 15.0001H5.41408L7.70705 17.293C8.09752 17.6836 8.09755 18.3166 7.70705 18.7071C7.31654 19.0976 6.68351 19.0976 6.29298 18.7071L2.29298 14.7071C2.007 14.4211 1.92144 13.9909 2.07619 13.6173C2.231 13.2437 2.5956 13.0001 3.00002 13.0001H17Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.293 5.29305C16.6835 4.90252 17.3165 4.90252 17.707 5.29305L21.707 9.29305C21.993 9.57904 22.0786 10.0092 21.9238 10.3829C21.769 10.7565 21.4044 11.0001 21 11.0001H7.00002C6.44776 11.0001 6.00006 10.5523 6.00002 10.0001C6.00002 9.44779 6.44773 9.00008 7.00002 9.00008H18.586L16.293 6.70711C15.9025 6.31659 15.9025 5.68357 16.293 5.29305Z",
		fill: "currentColor"
	})]
});
export default SvgArrowsExchange;
